/**
 * @generated SignedSource<<cdc432bd119679c8b344fe7e174b94a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CurrencyType = "CAD" | "EUR" | "USD" | "%future added value";
export type InsightMetricFilterField = "KpiAbsent" | "KpiPresent" | "LabelLift" | "NumberOfAdsAbsent" | "NumberOfAdsPresent" | "SpendAbsent" | "SpendPresent" | "%future added value";
export type InsightV2OrderBy = "AD_SPEND_ABSENT_ASC" | "AD_SPEND_ABSENT_DESC" | "AD_SPEND_PRESENT_ASC" | "AD_SPEND_PRESENT_DESC" | "COUNT_ABSENT_ASC" | "COUNT_ABSENT_DESC" | "COUNT_PRESENT_ASC" | "COUNT_PRESENT_DESC" | "DELTA_ASC" | "DELTA_DESC" | "LABEL_LIFT_ASC" | "LABEL_LIFT_DESC" | "LABEL_NAME_ASC" | "LABEL_NAME_DESC" | "LABEL_TYPE_ASC" | "LABEL_TYPE_DESC" | "RATE_WHEN_ABSENT_ASC" | "RATE_WHEN_ABSENT_DESC" | "RATE_WHEN_PRESENT_ASC" | "RATE_WHEN_PRESENT_DESC" | "%future added value";
export type KPI = "AGGREGATE_CONVERSION_RATE" | "AVG_DAILY_PURCHASE_VOLUME" | "AVG_DAILY_SPEND" | "CLICK_THROUGH_RATE" | "CONVERSION_RATE" | "COST_PER_ADD_TO_CART" | "COST_PER_COMPLETED_REGISTRATION" | "COST_PER_DONATION" | "COST_PER_ENGAGEMENT" | "COST_PER_INITIATED_CHECKOUT" | "COST_PER_INSTALL" | "COST_PER_LANDING_PAGE_VIEW" | "COST_PER_LEAD" | "COST_PER_LINK_CLICK" | "COST_PER_PURCHASE" | "COST_PER_STORE_LOCATOR" | "COST_PER_TOTAL_PURCHASE" | "COST_PER_TRIAL_STARTED" | "CPM" | "ENGAGEMENT_RATE" | "HOOK_RATE" | "IMPRESSIONS" | "LANDING_PAGE_VIEW_RATE" | "LEAD_CONVERSION_RATE" | "LEAD_RATE" | "PURCHASES" | "PURCHASES_CONVERSION" | "PURCHASES_TO_IMPRESSIONS" | "PURCHASES_TO_LINK_CLICK" | "PURCHASES_TO_LPV" | "REACH" | "RESULT_RATE" | "ROAS" | "SPEND" | "TOTAL_ROAS" | "TRIALS_STARTED" | "TRIALS_STARTED_TO_IMPRESSIONS" | "WEBSITE_PURCHASES" | "%future added value";
export type LabelType = "DOMINANT_COLOR" | "HEADLINE" | "HOOK_TEXT" | "IMAGE" | "NOUN" | "PHRASE" | "TAG" | "THEME" | "VERB" | "VIDEO" | "%future added value";
export type MetricFilterOperator = "EQ" | "GT" | "GTE" | "LT" | "LTE" | "NE" | "%future added value";
export type ListInsightV2Request = {
  filter: InsightV2Filter;
  orderBy?: InsightV2OrderBy | null;
  pagination?: PaginationInput | null;
};
export type PaginationInput = {
  skip?: number | null;
  take?: number | null;
};
export type InsightV2Filter = {
  brandId: string;
  delta_gt?: number | null;
  delta_lt?: number | null;
  includeAllDates?: boolean | null;
  kpi: KPI;
  labelTypes: ReadonlyArray<LabelType>;
  metrics?: ReadonlyArray<InsightMetricFilter> | null;
  performanceDateRange?: DateRangeInput | null;
  searchQueries?: ReadonlyArray<SearchQuery> | null;
};
export type SearchQuery = {
  fieldKey: string;
  type: string;
  value: string;
};
export type DateRangeInput = {
  end: string;
  start: string;
};
export type InsightMetricFilter = {
  fieldKey: InsightMetricFilterField;
  operator: MetricFilterOperator;
  value: number;
};
export type InsightsTableQuery$variables = {
  input: ListInsightV2Request;
  skip: boolean;
};
export type InsightsTableQuery$data = {
  readonly listInsightV2?: {
    readonly count: number;
    readonly data: ReadonlyArray<{
      readonly adSpendAbsent: number | null;
      readonly adSpendPresent: number | null;
      readonly contentTexts: ReadonlyArray<string | null> | null;
      readonly contentUrls: ReadonlyArray<string | null> | null;
      readonly id: string | null;
      readonly labelLift: number | null;
      readonly labelName: string | null;
      readonly labelType: LabelType;
      readonly metaAds: ReadonlyArray<string | null> | null;
      readonly numAbsent: number | null;
      readonly numPresent: number | null;
      readonly rateWhenAbsent: number | null;
      readonly rateWhenPresent: number | null;
    }>;
    readonly metadata: {
      readonly currencyType: CurrencyType | null;
    };
    readonly pageInfo: {
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
    };
  };
};
export type InsightsTableQuery = {
  response: InsightsTableQuery$data;
  variables: InsightsTableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "InsightV2List",
        "kind": "LinkedField",
        "name": "listInsightV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InsightV2Metadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyType",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InsightV2",
            "kind": "LinkedField",
            "name": "data",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "labelName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "labelType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "labelLift",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rateWhenAbsent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rateWhenPresent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "adSpendPresent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "adSpendAbsent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numPresent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numAbsent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contentUrls",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contentTexts",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "metaAds",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InsightsTableQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InsightsTableQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0d8e372fbb590138f70eb3e9dc3bfef0",
    "id": null,
    "metadata": {},
    "name": "InsightsTableQuery",
    "operationKind": "query",
    "text": "query InsightsTableQuery(\n  $input: ListInsightV2Request!\n  $skip: Boolean!\n) {\n  listInsightV2(input: $input) @skip(if: $skip) {\n    count\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n    }\n    metadata {\n      currencyType\n    }\n    data {\n      id\n      labelName\n      labelType\n      labelLift\n      rateWhenAbsent\n      rateWhenPresent\n      adSpendPresent\n      adSpendAbsent\n      numPresent\n      numAbsent\n      contentUrls\n      contentTexts\n      metaAds\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c488f11e761c4d8d6fc45867eaf33ce7";

export default node;
